import * as types from './types';

export const getRestaurants = (payload) => ({
  type: types.RESTAURANTS_GET_REQUEST,
  payload,
});

export const getSelectedRestaurant = payload => ({
  type: types.RESTAURANTS_GET_SELECTED_REQUEST,
  payload,
});

export const resetRestaurantsListData = () => ({
  type: types.RESTAURANTS_RESET_LIST_DATA,
  payload: {
    id: 'restaurants',
    title: 'Anagrafica insegna:',
    description:
      'Qui puoi creare e modificare i dati anagrafici relativi alla/e tua/e insegne.',
    href: '/profile/restaurant/:id',
    createLink: '/profile/restaurant/create',
    loading: false,
    items: [],
  }
});

export const getRestaurantById = (payload) => ({
  type: types.RESTAURANT_BY_ID_GET_REQUEST,
  payload,
});

export const resetCurrentRestaurant = () => ({
  type: types.RESTAURANT_BY_ID_GET_SUCCESS,
  payload: {},
});

export const updateOrCreateRestaurant = payload => ({
  type: types.RESTAURANT_CREATE_OR_UPDATE_REQUEST,
  payload,
});

export const deleteRestaurantRequest = payload => ({
  type: types.RESTAURANT_DELETE_REQUEST,
  payload,
});

export const resetErrors = () => ({
  type: types.RESTAURANT_CREATE_OR_UPDATE_FAILURE,
  payload: null,
});

export const restaurantDeleteFailure = (error) => ({
  type: types.RESTAURANT_DELETE_FAILURE,
  payload: error,
});

export const usersBulkCreateRequest = (payload) => ({
  type: types.USERS_BULK_CREATE_REQUEST,
  payload,
});

export const usersBulkCreateSuccess = () => ({
  type: types.USERS_BULK_CREATE_SUCCESS,
});

export const usersBulkCreateFailure = (error) => ({
  type: types.USERS_BULK_CREATE_FAILURE,
  payload: error,
});
